export interface IUserInfo {
	id: string;
	displayName: string;
}

export enum UserClaims {
	NO_ADS = "NO_ADS",
	ALLOW_EXPORT = "ALLOW_EXPORT",
	ALLOW_CURRENCY_DATA = "ALLOW_CURRENCY_DATA",
	HAVE_SUBSCRIPTION = "HAVE_SUBSCRIPTION"
}

export interface IUserAuthorization {
	isBlocked: boolean;
	haveClaim: (claim: UserClaims) => boolean;
}

export interface IAuthPlugin {
	readonly displayName: string;

	useAuthentication(): Promise<IAuthApi>;
}

export interface IAuthApi {
	signIn(): Promise<void>;
}